export const LIST_NON_INVASIVE_WOODY = 'Non-Invasive Woody';
export const LIST_NON_INVASIVE_TREES = 'Non-Invasive Trees';
export const LIST_INVASIVE_GROUND_COVER = 'Invasive + Ground Cover';
export const LIST_PROBLEMATIC = 'Problematic';
export const LIST_NATIVE_OR_UNKNOWN_WOODY = 'Native or Unknown Woody';
export const LIST_NATIVE_WOODY = 'Native Woody';
